import { FC } from "react";
import Markdown from "react-markdown";
import { useGetChatQuestions } from "~/api/chat/chat";
import { GetChatQuestions200QuestionsItem } from "~/api/model";
import { useChatDocumentParams } from "~/helpers";

interface ChatSuggestionsProps {
  onSuggestionClick: (suggestion: GetChatQuestions200QuestionsItem) => void;
}

const DEFAULT_SUGGESTIONS: GetChatQuestions200QuestionsItem[] = [
  { id: "1", value: "What's important here?" },
  { id: "2", value: "What's covered?" },
  { id: "3", value: "What's the claim status?" },
];

export const SuggestQuestions: FC<ChatSuggestionsProps> = ({
  onSuggestionClick,
}) => {
  const { organizationId, caseId, chatId } = useChatDocumentParams();
  const { data: questions, isLoading } = useGetChatQuestions(
    organizationId,
    caseId,
    chatId,
    {
      query: {
        select: (data) =>
          data.questions.length > 0 ? data.questions : DEFAULT_SUGGESTIONS,
      },
    }
  );

  if (isLoading) {
    return (
      <div className="flex flex-col gap-2">
        <div className="px-3 py-2 rounded-md border border-zinc-200 bg-gray-100 animate-pulse" />
        <div className="px-3 py-2 rounded-md border border-zinc-200 bg-gray-100 animate-pulse" />
        <div className="px-3 py-2 rounded-md border border-zinc-200 bg-gray-100 animate-pulse" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {(questions ?? []).map((suggestion) => (
        <div
          key={suggestion.id}
          className="px-3 py-2 rounded-md border border-zinc-200 justify-start items-center inline-flex cursor-pointer hover:bg-white transition-colors"
          onClick={() => onSuggestionClick(suggestion)}
        >
          <Markdown className="text-zinc-900 text-sm">
            {suggestion.value}
          </Markdown>
        </div>
      ))}
    </div>
  );
};
